
import {
  Button,
  Dropdown,
  Form,
  Input,
  Modal,
  message,
  Select,
  Space,
  Tooltip,
} from "antd";
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
  useRef,
} from "react";
import http from "@/utils/http";
import api from "@/utils/api";
import dayjs from "dayjs";
import "./UtilityPayment.scss"
import {
  FormOutlined,
  MenuOutlined,
  QuestionCircleOutlined,
  DeleteOutlined
} from "@ant-design/icons";
import moment from "moment";
import AddModal from "./AddModal" ;
import ParamEditModal from "./ParamEditModal" ;
import { CustomTable } from "@/hocComponents";
import commonFn from "@/utils/commonFn";
import { range } from "lodash";

const MainTable = forwardRef((props, ref) => {
  const [addRecord, setAddRecord] = useState(null);
  const [compareOpen, setCompareOpen] = useState(false);
  const [compareLoading, setCompareLoading] = useState(false);
  const [form] = Form.useForm();
  const [formCompare] = Form.useForm();
  const [formTenant] = Form.useForm();
  const [addopen, setAddOpen] = useState(false);
  const [greater, setGreater] = useState([]);
  const [small, setSmall] = useState([]);

  const [payByList, setPayByList] = useState([]);
  const [payFreqList, setPayFreqList] = useState([]);
  const [propTypeList, setPropTypeList] = useState([]);
  const [dynamicColumns, setDynamicColumns] = useState([]);

  const initTableHead = {
    name: null,
    mailingStr: null,
    prop: null,
    numberOfUnits: null,
    propType: null,
    streetCity: null,
    remark: null,
    customerAccount: null,
    meterNumber: null,
    payBy: null,
    payFreq: null,
    dueDate: null,
    glAcct: null,
  }
  const [tableHead, setTableHead] = useState(initTableHead);

  const tableFilterFn = (event, key, type = 'Input') => {
    commonFn.tableFilterFn({event, key, type, setTableHead, getTableListFn})
  }
  // 定义列，包括输入框
  const initColumns = [
    // {
    //   title: '#',
    //   dataIndex: '#'
    // },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      hidden: false,
      width: 60,
      align: "center",
      render: (text, record, index) => (
        (
          commonFn.btnAuthorityFlag('Edit') ||
          commonFn.btnAuthorityFlag('Delete')
        ) && (<Dropdown
          menu={{
            items: [
              commonFn.btnAuthorityFlag('Edit') && {
                key: "edit",
                icon: <FormOutlined twoToneColor="#1677FF" />,
                label: <div>Edit</div>,
              },
              commonFn.btnAuthorityFlag('Delete') && {
                key: "delete",
                icon: <DeleteOutlined twoToneColor="#1677FF" />,
                label: <div>Delete</div>,
              },
            ],
            onClick: (e) => props.onMenuClick(e, record),
          }}
          trigger={["click"]}
        >
          <MenuOutlined className="col-blue" />
        </Dropdown>) || null
      ),
    },
    {
      title: "Vendor Name",
      dataIndex: "name",
      titleType: "Input",
      isSorter: true,
      width: 140,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, 'name'),
    },
    {
      title: "Mailing St - City",
      dataIndex: "mailingStr",
      titleType: "Input",
      isSorter: true,
      width: 140,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, 'mailingStr'),
      render: (text, record, index) => {
        const first = record?.mailList?.[0] || ''
        const second = record?.mailList?.[1] || ''
        if(first && second){
          return <>
            <div>{first}</div>
            <div>{second}</div>
          </>
        } else {
          return <div>{first || second}</div>
        }
      },
    },
    {
      title: "Prop",
      dataIndex: "prop",
      titleType: "Input",
      isSorter: true,
      width: 80,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, 'prop'),
    },
    {
      title: "Units",
      dataIndex: "numberOfUnits",
      titleType: "Input",
      isSorter: true,
      width: 80,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, 'numberOfUnits'),
    },
    {
      title: "Prop Type",
      dataIndex: "propType",
      key: "propType",
      hidden: false,
      align: "center",
      isSorter: true,
      sortterMultiple: 2,
      titleType: "Select",
      selectOptions: propTypeList,
      onChange: (e) => tableFilterFn(e, 'propType', 'Select'),
    },
    {
      title: "Street - City",
      dataIndex: "streetCity",
      titleType: "Input",
      isSorter: true,
      width: 140,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, 'streetCity'),
    },
    {
      title: "Check Memo",
      dataIndex: "remark",
      titleType: "Input",
      isSorter: true,
      width: 140,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, 'remark'),
      render: (text, record, index) => {
        return changeTableRenderFn(record, 'remark', "Input")
      },
    },
    {
      title: "Acct. / Customer #",
      dataIndex: "customerAccount",
      titleType: "Input",
      isSorter: true,
      width: 130,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, 'customerAccount'),
      render: (text, record, index) => {
        return (
          <span
            onClick={(e) => {
              e.preventDefault();
              handleCellClickAccount(record);
            }}
            className="custom-border-bottom"
            style={{ border: 0 }}
          >
            {text}
          </span>
        );
      },
    },
    {
      title: "Meter #",
      dataIndex: "meterNumber",
      titleType: "Input",
      isSorter: true,
      width: 120,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, 'meterNumber'),
    },
    {
      title: "Pay By",
      dataIndex: "payBy",
      key: "payBy",
      hidden: false,
      align: "center",
      isSorter: true,
      sortterMultiple: 2,
      titleType: "Select",
      selectOptions: payByList,
      onChange: (e) => tableFilterFn(e, 'payBy', 'Select'),
    },
    {
      title: "Pay Freq",
      dataIndex: "payFreq",
      key: "payFreq",
      hidden: false,
      align: "center",
      isSorter: true,
      sortterMultiple: 2,
      titleType: "Select",
      selectOptions: payFreqList,
      onChange: (e) => tableFilterFn(e, 'payFreq', 'Select'),
      render: (text, record, index) => {
        return changeTableRenderFn(record, 'payFreq', "Select")
      },
    },
    {
      title: 'Due Date',
      dataIndex: "dueDate",
      titleType: "DatePicker",
      width: 100,
      onChange: (e) => tableFilterFn(e, 'dueDate', 'DatePicker'),
      render: (text, record, index) => {
        return changeTableRenderFn(record, 'dueDate', "DatePicker")
      },
    },
    {
      title: "Gl Acct",
      dataIndex: "glAcct",
      titleType: "Input",
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, 'glAcct'),
    },
  ];

  const [columns, setColumns] = useState(initColumns);
  const [tableList, setTableList] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 25,
    total: 0,
  });

  const showItemFn = (record, key, type) => {
      switch (type) {
        case 'Input':
          return record?.[key] || 'Empty'
        case 'Select':
          return payFreqList?.find(item => item.value == record?.[key])?.label  || 'Empty'
        case 'DatePicker':
          return (record?.[key] == '0000-00-00' || !record?.[key]) ? 'Empty' : record?.[key]
        default:
          break;
      }
  }

  const paramEditModalRef = useRef(null);
  const [paramEditRecord, setParamEditRecord] = useState({});

  const changeTableRenderFn = (record, key, type) => {
    const value = showItemFn(record, key, type)
    const dueDateFlag = key === 'dueDate'
    return (
      <>
        <Tooltip title={value}>
            <span
              onClick={(e) => {
                e.preventDefault();
                setParamEditRecord(record)
                paramEditModalRef.current.openModal(true)
              }}
              className="custom-border-bottom custom-ellipsis"
              style={{ display: 'inline-block', }}
            >
              {
                dueDateFlag ? (value ==='Empty' ? 'Empty' : (value && moment(value).format("MM/DD/YYYY") || "")) : value
              }
            </span>
        </Tooltip>
      </>
    )
  }
  
  const initColunmsFn = () => {
    setTableHead(initTableHead);
    setColumns([...initColumns, ...dynamicColumns]);
  }

  // 初始化数据
  useEffect(() => {
    initColunmsFn()
    getTableListFn(1, 25)
  }, [props.refreshKey]);

  // 获取动态表头数据并更新 columns
  useEffect(() => {
    const fetchDynamicColumns = async () => {
      const response = await http.get(api.Title);
      if(!Array.isArray(response)) return
      const dynamicColumns = (response || [])?.map((month) => ({
        title: month,
        dataIndex: month,
        key: month,
        width: 100,
        onCell: () => ({className: 'cellAmount'}),
        render: (text, record) => {
          const paymentAmount = record?.paymentAmount?.[month] || [];
          const hasData = paymentAmount?.length > 0;
          return (
            <>
              {hasData ? (
                paymentAmount.map((val, index) => (
                  <React.Fragment key={`${record.vendorUtilPaymentId}_${month}_${index}`}>
                    <div className={(record?.month == month) && 'cellColor' || ''}>
                      <span
                        onClick={() =>
                          handleCellClick(
                            record,
                            val,
                            true
                          )
                        }
                        style={{
                          cursor: "pointer",
                          color: val?.color || "#3c8dbc",
                          fontWeight: "bold",
                          textDecoration: "underline",
                        }}
                      >
                        {`${commonFn.amountToDollarFn(val.amount)}${(val?.color == "#f39c12") && '(V)' || ''}`}
                      </span>
                      {index !== paymentAmount?.length - 1 && ", "}
                    </div>
                  </React.Fragment>
                ))
              ) : (
                <span
                  onClick={() =>
                    handleCellClick(
                      record,
                      record.lastPaymentAmount
                    )
                  }
                  style={{
                    cursor: "pointer",
                    color: "#3c8dbc",
                    fontWeight: "bold",
                    textDecoration: "underline",
                  }}
                  >$---</span>
              )}
            </>
          );
        },
      }));
      setDynamicColumns(dynamicColumns)
      setColumns([...initColumns, ...dynamicColumns]);
    };
  
    fetchDynamicColumns();
  }, [greater, small]);

  const handleCellClick = async (record, val= {}, flag = false) => {
    const invoiceDateTemp = dayjs(flag ? val.invoiceDate : new Date())
    setAddRecord({ 
      ...record,
      ...val,
      invoiceDate: invoiceDateTemp,
      amount: val?.amount || 0,
      serviceStartDate: val?.serviceStartDate && dayjs(val?.serviceStartDate) || null,
      serviceEndDate: val?.serviceEndDate && dayjs(val?.serviceEndDate) || null,
      invoiceTenantDate: val?.invoiceTenantDate && dayjs(val?.invoiceTenantDate) || null,
      invoiceTenant: val?.isInvTenant ? (!val?.invoiceTenant ? '0' : '1') : (record?.payBy === "Owner" ? '0' : '1'),
      foreignId: val?.foreignId || record?.vendorUtilPaymentId,
      filePaths: val?.filePaths || [],
      isEdit: flag,
      noSubmitBtn: flag ? val?.isNoSubmitBtn : false
    });
    setAddOpen(true);
  };

  const handleCellClickAccount = (record) => {
    const baseUrl = window.location.origin;
    const route = "/AccountPayable/UtilityPayment/UtilityPaymentMonths";
    const url = `${baseUrl}#${route}?vendorUtilPaymentId=${record.vendorUtilPaymentId}`;

    window.open(url, "_blank", "noopener,noreferrer");
  };

  useEffect(() => {
    getDictionaryFn('payBy')
    getDictionaryFn('payFreq')
    getDictionaryFn('propType')
  }, []);

  const getDictionaryFn = async(value) => {
    const params = {
        type:'util_payment',
        value
    }
    const response = await http.get(api.getDictionary, { params });
    switch (value) {
      case 'payBy':
        setPayByList(response)
        break;
      case 'payFreq':
        setPayFreqList(response)
        break;
      case 'propType':
        setPropTypeList(response)
        break;
      default:
        break;
    }

  }

  const getTableListFn = async (current, pageSize, tableHead = {}) => {
    setTableLoading(true);
    const params = {
      page: current || pagination.current,
      count: pageSize || pagination.pageSize,
      ...tableHead
    };
    const response = await http.get(api.UtilPayment, { params });
    if (response?.code !== "1") {
      commonFn.modalFailedFn(response)
      setTableLoading(false);
      return
    }
    const list = (response.data.list || []).map((item, index) => ({ ...item, '#': (params.page - 1) * params.count + index + 1}));
    setTableList(list);
    setPagination((prev) => ({
      ...prev,
      total: response.data.total || 0,
      current: params.page,
      pageSize: params.count,
    }));
    setTableLoading(false);
    // 修改账单颜色
    const vendorUtilPaymentIds = list
      .filter(
        (item) =>item?.vendorUtilPaymentId
      ) // 过滤掉没有 vendorUtilPaymentId 的项
      .map((item) => item.vendorUtilPaymentId);

    if (vendorUtilPaymentIds?.length) {
      const paymentIds = vendorUtilPaymentIds.join(",");
      const result = await http.get(api.UtilPaymentRecent, {params: {ids: String(paymentIds)}});
      setGreater(result?.greater || []); 
      setSmall(result?.small || []);  
    }
  };

  // 处理分页变化
  const handleTableChange = (pagination, filters, sorter) => {
    getTableListFn(pagination.current, pagination.pageSize, tableHead);
  };

  //model关闭
  const handleCancel = () => {
    form.resetFields();
    setCompareOpen(false);
  };

  // 表单compare提交
  const compareFinish = async (values) => {
    setCompareLoading(true)
    const data = {
      compare: values.compare,
      account: values.account,
      id: 1,
    };
    const response = await http.post(api.Compare, data, {
      headers: {
        "Content-Type": "application/json", 
      },
    });
    if(response.code === '1'){
      message.success("Compare successfully"); 
      setCompareOpen(false);
      getTableListFn(1, 25);   
    }
    setCompareLoading(false)
  };

  const paramEditModalSubmitlFn = (params) => {
    const list = tableList.map(item =>
      item?.vendorUtilPaymentId === paramEditRecord?.vendorUtilPaymentId
        ? { ...item, ...params }
        : item
    );
    setTableList(list)
  }
  
  const compareLabelDocFn = (value) => {
    const compareLabelMatch = {
      'Percentage': 'If the current payment is higher or lower than filled in percentage. Transaction gets highlighted.',
      'Quantity': 'Calculate the average of (s) of previous consecutive payments.',
    }
    return (
      <span>
        {value}
        <Tooltip title={compareLabelMatch[value]}>
            <QuestionCircleOutlined style={{color: '#00c0ef', marginLeft: '4px'}} />
        </Tooltip>
      </span>
    )
  }

  // 暴露子组件方法
  useImperativeHandle(ref, () => ({
    fetchDataFn: (current, pageSize) => {
      getTableListFn(current || pagination.current, pageSize || pagination.pageSize, tableHead);
    },
    showCompare: () => setCompareOpen(true),
    getColumns: () => columns,
    setColumnsFn: () => setColumns,
    getInitColumns: () => initColumns,
    getTableHead:() => tableHead
  }));

  return (
    <div>
      <CustomTable 
        refreshKey={props.refreshKey}
        tableLoading={tableLoading}
        rowKey="vendorUtilPaymentId"
        columns={columns}
        tableList={tableList}
        pagination={pagination}
        handleTableChange={handleTableChange}
        rowClassName={(record) => {
          if(greater.includes(record.vendorUtilPaymentId)){
            return ["greater-row-date"]
          }
          if(small.includes(record.vendorUtilPaymentId)){
            return ["small-row-date"]
          }
          return [record.vendorUtilPaymentId]
        }}
        scroll={{
          x: 1690,// 2290
          y: "calc(100vh - 280px)",
        }}
      />
      {/* compare表单 */}
      <Modal
        title={
          <div style={{ fontSize: "24px", fontWeight: "bold", color: "red" }}>
            EDIT PAYMENT
            <div
              style={{ borderTop: "3px solid #3c8dbc", marginTop: "8px" }}
            ></div>
          </div>
        }
        centered
        open={compareOpen}
        onCancel={() => setCompareOpen(false)}
        footer={null}
        width="40%"
        maskClosable={false}
      >
        <Form
          form={formCompare}
          layout="vertical"
          onFinish={compareFinish}
          style={{
            maxWidth: 400,
            margin: "0 auto",
            padding: "20px",
            border: "1px solid #d9d9d9",
            border: "none",
            borderRadius: "8px",
          }}
        >
          <h3 style={{ textAlign: "center", marginBottom: "20px" }}>
            Calculation Rule
          </h3>

          <Form.Item
            name="compare"
            label={compareLabelDocFn("Percentage")}
            rules={[
              { required: true, message: "Please enter the percentage!" },
              {
                pattern: /^[1-9]$|^[1-9][0-9]$|^100$/, // 允许的正则：1-100之间的数字，且不能是小数
                message: "Please enter a valid number between 1 and 100!",
              },
            ]}
          >
            <Input placeholder="Enter percentage" />
          </Form.Item>

          <Form.Item
            name="account"
            label={compareLabelDocFn("Quantity")}
            rules={[{ required: true, message: "Please select a quantity!" }]}
          >
            <Select 
              placeholder="Select quantity"
              options={range(1, 13).map(item => (
                { value: String(item), label: item }
              ))}
            >
            </Select>
          </Form.Item>

          <Form.Item className="btnCenter">
            <Space align="center">
              <Button key="back" onClick={handleCancel}>
                cancel
              </Button>
              <Button loading={compareLoading} type="primary" htmlType="submit">
                Submit
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Modal>

      {/* 添加账单表单 */}
      <AddModal 
        addopen={addopen}
        form={form}
        formTenant={formTenant}
        handleModalSubmitlFn={() => {setAddOpen(false); getTableListFn(pagination.current, pagination.pageSize, tableHead)}}
        handleModalCancelFn={() => setAddOpen(false)}
        record={addRecord}
      />

       {/* 部分参数修改 */}
      <ParamEditModal 
        ref={paramEditModalRef}
        record={paramEditRecord}
        payFreqList={payFreqList}
        paramEditModalSubmitlFn={(params) => paramEditModalSubmitlFn(params)}
      />
    </div>
  );
});
export default MainTable;
